const sections = [
  {
    id: "sec-1",
    title: "本页内容",
    links: [
      { id: "platforms", label: "观看平台一览" },
      { id: "titles", label: "分类片单" },
      { id: "subtitles", label: "字幕类型科普" },
      { id: "tips", label: "选片贴士" },
      { id: "faq", label: "常见问答" },
    ],
  },
  {
    id: "sec-2",
    title: "选片维度",
    links: [
      { id: "d1", label: "按语种：日语 / 韩语" },
      { id: "d2", label: "按类型：剧集 / 电影" },
      { id: "d3", label: "按题材：悬疑 / 治愈 / 家庭" },
      { id: "d4", label: "按字幕：软字幕 / 硬字幕" },
    ],
  },
  {
    id: "sec-3",
    title: "观影提醒",
    links: [
      { id: "n1", label: "优先选择正版平台" },
      { id: "n2", label: "留意地区版权差异" },
      { id: "n3", label: "字幕以平台实时信息为准" },
      { id: "n4", label: "支持创作者与翻译者" },
    ],
  },
];

export default function Footer() {
  const goTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="w-full bg-secondary-900 text-secondary-100">
      <div className="px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-secondary-50">
                日韩中文字幕
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200/90 max-w-sm">
              一份专注日韩影视中文观看体验的指南，帮你找到合适的正版平台、看懂字幕差异，把时间花在好作品上。
            </p>
          </div>

          {sections.map((s) => (
            <div key={s.id}>
              <h4 className="font-heading text-sm font-semibold text-secondary-50">{s.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {s.links.map((l) => (
                  <li key={l.id}>
                    <button
                      onClick={() => goTo(l.id)}
                      className="text-sm text-secondary-200/85 hover:text-secondary-50 transition-colors cursor-pointer text-left"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300/80">
            © 2026 日韩中文字幕观影指南 · 本页仅提供观影信息整理，不提供任何资源下载或播放链接。
          </p>
          <p className="text-xs text-secondary-300/80">内容以各正版平台实时信息为准</p>
        </div>
      </div>
    </footer>
  );
}